import {
  LayoutDashboard, Users, KanbanSquare, MessageCircle, Calendar, UserRound,
  FileText, Wallet, FileSignature, Receipt, Megaphone, Zap, Brain,
  BarChart3, PieChart, ShieldCheck, Settings, Building2, Plug, FolderArchive, Crown,
  Rocket, CreditCard, Activity, LifeBuoy, ScrollText, SlidersHorizontal,
} from "lucide-react";

/**
 * Estrutura dos menus.
 *
 * Fica separada dos componentes de propósito: adicionar uma tela é editar
 * esta lista, sem tocar em JSX. No app antigo os itens estavam embutidos no
 * meio do componente da barra lateral, duplicados entre o menu da clínica e
 * o do Master.
 *
 * `ready: false` marca os módulos que ainda são placeholder — a tela existe
 * e o item aparece no menu, exatamente como hoje.
 */

/** @typedef {{ title: string, url: string, icon: any, ready?: boolean }} ItemMenu */
/** @typedef {{ label: string, items: ItemMenu[] }} GrupoMenu */

/** @type {GrupoMenu[]} */
export const CLINIC_NAV = [
  {
    label: "Operação",
    items: [
      { title: "Dashboard", url: "/dashboard", icon: LayoutDashboard, ready: true },
      { title: "Leads", url: "/leads", icon: Users, ready: true },
      { title: "CRM Comercial", url: "/crm", icon: KanbanSquare, ready: true },
      { title: "WhatsApp", url: "/whatsapp", icon: MessageCircle, ready: true },
      { title: "Automação", url: "/automacao", icon: Zap, ready: true },
    ],
  },
  {
    label: "Clínico",
    items: [
      { title: "Agenda", url: "/agenda", icon: Calendar, ready: true },
      { title: "Pacientes", url: "/pacientes", icon: UserRound },
      { title: "Prontuário", url: "/prontuario", icon: FileText },
      { title: "Orçamentos", url: "/orcamentos", icon: Receipt },
      { title: "Contratos", url: "/contratos", icon: FileSignature },
      { title: "Financeiro", url: "/financeiro", icon: Wallet },
    ],
  },
  {
    label: "Inteligência",
    items: [
      { title: "Marketing", url: "/marketing", icon: Megaphone },
      { title: "Inteligência Artificial", url: "/ia", icon: Brain },
      { title: "Relatórios", url: "/relatorios", icon: BarChart3 },
      { title: "Business Intelligence", url: "/bi", icon: PieChart },
    ],
  },
  {
    label: "Sistema",
    items: [
      { title: "Usuários e Permissões", url: "/usuarios", icon: ShieldCheck, ready: true },
      { title: "Multiunidades", url: "/multiunidades", icon: Building2 },
      { title: "Integrações", url: "/integracoes", icon: Plug, ready: true },
      { title: "Central de Arquivos", url: "/arquivos", icon: FolderArchive },
      { title: "Configurações", url: "/configuracoes", icon: Settings, ready: true },
    ],
  },
];

/** @type {GrupoMenu[]} */
export const MASTER_NAV = [
  {
    label: "Administração",
    items: [
      { title: "Dashboard Geral", url: "/master", icon: LayoutDashboard, ready: true },
      { title: "Clientes", url: "/master/clientes", icon: Building2, ready: true },
      { title: "Onboarding e Setup", url: "/master/onboarding", icon: Rocket, ready: true },
      { title: "Assinaturas", url: "/master/assinaturas", icon: CreditCard, ready: true },
      { title: "Cobranças", url: "/master/cobrancas", icon: Receipt, ready: true },
      { title: "Utilização da Plataforma", url: "/master/utilizacao", icon: Activity, ready: true },
      { title: "Suporte", url: "/master/suporte", icon: LifeBuoy, ready: true },
      { title: "Usuários Master", url: "/master/usuarios", icon: ShieldCheck, ready: true },
      { title: "Auditoria", url: "/master/auditoria", icon: ScrollText, ready: true },
      { title: "Configurações Globais", url: "/master/configuracoes", icon: SlidersHorizontal, ready: true },
    ],
  },
];

export const MASTER_ENTRY = { title: "OdontoPlug Master", url: "/master", icon: Crown };

/**
 * Um item está ativo quando é a rota exata ou um ancestral dela — mas
 * `/master` não pode acender em `/master/clientes`, senão dois itens ficam
 * destacados ao mesmo tempo.
 * @param {string} pathname @param {string} url
 */
export function isActiveRoute(pathname, url) {
  if (url === "/master" || url === "/dashboard") return pathname === url;
  return pathname === url || pathname.startsWith(url + "/");
}
